// const Sentry = require('@sentry/node');

class ErrorHandlingService {
    handleException(exception) {
        console.error(`${exception.name} ${exception.message}`);
        console.error(exception.stack);
        // Sentry.captureException(exception);
    }
}

export default new ErrorHandlingService();



// WEBPACK FOOTER //
// ./src/services/error-handling.service.js